import {
  GridItem,
  InverseHeader,
  LayoutGrid,
  TypographyV3,
} from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';

import Motion from '@/app/components/Motion';
import RichText from '@/app/components/RichText';
import SectionHeading from '@/app/components/SectionHeading';

import ExpandableCards from './ExpandableCards';

const tValues = {
  em: (chunks: ReactNode) => <em className="font-serif italic">{chunks}</em>,
  sup: (chunks: ReactNode) => (
    <sup className="relative -top-4 left-1 text-base font-bold md:-top-8 md:left-2 lg:-top-10">
      {chunks}
    </sup>
  ),
};

const WhyOuraWellness = () => {
  const t = useTranslations();
  return (
    <section className="relative py-16 lg:pt-32" data-cy="why-oura-wellness">
      <LayoutGrid className="overflow-hidden">
        <GridItem
          className="pb-16 lg:px-4 lg:pb-32"
          colEnd={{ sm: 'main', md: 21, lg: 20 }}
          colStart={{ sm: 'main', md: 5, lg: 6 }}
        >
          <Motion
            initial={{ filter: 'blur(10px)' }}
            whileInView={{ filter: 'blur(0px)', transition: { duration: 1 } }}
            viewport={{ once: true }}
          >
            <TypographyV3 variant="h1" align="center" height="tight">
              <RichText messageKey="wellness_title" tValues={tValues} />
            </TypographyV3>
          </Motion>
        </GridItem>
        <GridItem
          className="pt-16 lg:pt-0 lg:pb-16"
          colEnd={{ sm: 'main', md: 'main', lg: 15, xl: 12 }}
          colStart={{ sm: 'main', md: 'main', lg: 'main' }}
        >
          <SectionHeading
            animated
            content="wellness_subtitle"
            emAnimationProps={{
              transition: { duration: 2, type: 'tween', delay: 0.5 },
            }}
            indentation="text-right"
            multiline
            typographyProps={{
              className: 'leading-heading tracking-tighter',
              color: 'inherit',
              Element: 'h3',
              variant: 'h2',
            }}
            wrapperAnimationProps={{
              transition: { duration: 1.25, type: 'tween', delay: 0.25 },
            }}
          />
        </GridItem>
        <GridItem
          className="pt-6 pb-12 lg:pb-0"
          colEnd={{ sm: 'main' }}
          colStart={{ sm: 'main', lg: 16 }}
        >
          <TypographyV3>{t('wellness_description')}</TypographyV3>
        </GridItem>
        <GridItem
          colEnd={{ sm: 'full', lg: 'main' }}
          colStart={{ sm: 'full', lg: 'main' }}
        >
          <InverseHeader enter>
            <ExpandableCards />
          </InverseHeader>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default WhyOuraWellness;
